import futura from '../assets/futura.png'
import { useState } from 'react';
import close from '../assets/close.png'
import arrow from '../assets/arrow2.png'
import SimpleReactValidator from 'simple-react-validator';
function N2({ bookid, nextPage, previuosPage, home }) {

    const [age, setAge] = useState()
    const [info, setInfo] = useState()
    const [sex, setSex] = useState()
    const validator = new SimpleReactValidator({ autoForceUpdate: this });

    const editBook = () => {
        fetch(document.apiURL + '/book/' + bookid, {
            method: 'PUT',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "patient_age": age,
                "extra_info": info,
                "sex": sex
            })
        })
            .then(response => response.json())
            .then(response => {
                nextPage()
            });
    }

    const checkData = () => {
        if (validator.fieldValid('age')) {
            editBook()
        }
    }

    const [num, setNum] = useState()


    return (<>
        <div className="back-profilazione">


            <div className="square-center">
            <div className="flex row sp" style={{ borderRadius: '16px 16px 0px 0px' }}>

<img src={arrow} onClick={()=> previuosPage()} /> 
<img src={close} onClick={()=> home()} />  

</div>
                <div className="flex row center-con sp">
                    <h2 className="c">Ho bisogno di alcuni dettagli per l’intervento.</h2><img alt={"Logo Futura"} src={futura} className="min-fut">
                    </img>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Età del paziente*</h4>
                        <input value={age} name="age" onBlur={() => setNum(validator.fieldValid('age'))} type="text" className="input" style={{ width: '100%' }} placeholder="Inserisci età paziente" onChange={(e) => { setAge(e.target.value); validator.fieldValid('age') }}></input>
                        {validator.message('age', age, 'required|max:120,num')}

                        {validator.fieldValid('age') ? <p></p> : <p style={{color:'red'}}>*Assicurati di aver inserito il campo correttamente</p>}

                    </div>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col " style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Sesso del paziente:</h4>
                        <div className="flex row"><button onClick={() => setSex(0)} className={`button-sel ${sex === 0 ? 'selected' : null}`}>Maschio</button> <button onClick={() => setSex(1)} className={`button-sel ${sex === 1 ? 'selected' : null}`} style={{ marginLeft: '10px' }}>Femmina</button></div>


                    </div>
                </div>
                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Informazioni aggiuntive:</h4>
                        <textarea className="input" style={{ width: '100%', height: '90px' }} placeholder="Inserisci informazioni utili all'operatore" onChange={(e) => { setInfo(e.target.value) }}></textarea>
                        <button onClick={() => checkData()} className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }}>Continua</button>
                        <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessit&agrave; puoi contattare un nostro operatore al numero<br /> <a href='tel:+3908119312726'>081 193 12 726</a> che ti aiutera nella prenotazione.</p>
                    </div>
                </div>




            </div>
        </div>
    </>
    );
}

export default N2;